import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid } from "@material-ui/core";
import { ButtonHLPure, DialogPrivacy, DialogSystemGLPure, IconLanguageHLPure, TooltipHLPure } from "../../pures";
// import miFirmaLogoHeader from "../../../assets/logos/logo_akubicaFirmaDigital_New.png";
import SvgIcon from "@material-ui/core/SvgIcon";

import "./change-password.css";
import ProfileAdministrationPasswordView from "../profile-administration/profile-administration-password-view";
import { LocalStorageService } from "../../../services";
import { LogoColor } from "../../../assets/assets";

const ChangePasswordView = (props) => {
    const { t, i18n } = useTranslation();
    const [modalTermsCond, setValidationForm] = useState(false);
    const lastInputRef = useRef(null);
    const ContainerPasswordStyle = {
        display: "flex",
        justifyContent: "center",
        maxWidth: "500px",
        // padding: "10px",
        marginTop: "5%",
    };

    const openModalTermsCond = (value) => {
        setValidationForm(value);
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            props.onSubmitChangeUserPassword(t);
        }
    };
    const focusNext = (event) => {
        if (event.key === "Enter") {
            lastInputRef.current.focus();
        }
    };

    const changePreference = (language) => {
        if (!language) return
        language = language || "es"
        props.setFlagsPassword(language)
        LocalStorageService.storeItem("preferredLanguage", language)
        i18n.changeLanguage(language);
    }

    return (
        <div>
            {
                props.isProfileView ? (
                    <ProfileAdministrationPasswordView
                        {...props}
                    />
                ) : (
                    <div>
                        {/* Header of the page */}

                        {!props.goToChangePasswordScreen && (
                            <div className="change-password-container-header-new">
                                <div className="change-password-container-header-items">
                                    <img
                                        src={LogoColor}
                                        alt="Logo de govo.legal"
                                        width='247' height='57'
                                    />
                                    {(props.flags && props.flags.length > 0) && (
                                        <div className="loginView-flags-container">
                                            <div className="loginView-world">
                                                <img
                                                    src={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_LANGUAGE_WORLD}`}
                                                    width={22}
                                                    height={22}
                                                    alt={'worldLanguage'}
                                                />
                                            </div>
                                            {
                                                props.flagsPassword.map((flag) => (
                                                    <div className="loginView-flags"
                                                        onClick={() => changePreference(flag.language)}
                                                    >
                                                        <IconLanguageHLPure
                                                            label={flag.label}
                                                            status={flag.status}
                                                        />
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Container of body and Form */}
                        <div className="change-password-general-form-container">
                            <Container className="container" style={ContainerPasswordStyle}>
                                <Grid
                                    container
                                    xs={5}
                                    lg={5}
                                    md={5}
                                    sm={5}
                                    es={5}
                                    spacing={1}
                                    className="change-password-form-container-align"
                                >
                                    <div className="inline-tooltip">
                                        <label className="changePasswordView-title">
                                            {t("changePasswordView.titleMessage")}
                                            {t("changePasswordView.titleMessage2")}
                                            <TooltipHLPure
                                                titleTooltip={t("changePasswordView.tooltipTitleRecomendations")}
                                                descriptionTooltip={t("changePasswordView.tooltip.recomendations")}
                                                subContent={t("changePasswordView.tooltip.recomendations.pt2")}
                                                restContent={t("changePasswordView.tooltip.recomendations.pt3")}
                                                finalContent={t("changePasswordView.tooltip.recomendations.pt4")}
                                                positionTooltip={"right"}
                                                informationIcon
                                            />
                                        </label>
                                    </div>
                                    <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
                                        <Grid
                                            container
                                            xs={12}
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            es={12}
                                            spacing={2}
                                            className="change-password-form-grid-general-container"
                                        >
                                            {/* Input contraseña */}
                                            <Grid item xs={12}>
                                                <div className="change-password-input-container">
                                                    <div className="change-password-input-wrapper">
                                                        <i className="fas fa-lock change-password-input-icon" />
                                                    </div>
                                                    <input
                                                        placeholder={t("changePasswordView.placeholderPassword")}
                                                        type="password"
                                                        className="change-password-input"
                                                        id="password"
                                                        onChange={(e) => props.onHandleGeneralChange(e)}
                                                        onKeyDown={focusNext}
                                                    />
                                                    <div
                                                        className={`changePasswordView-show-password-icon ${props.changePasswordShowPasswordIcon}`}
                                                        onClick={props.onHandleShowPassword}
                                                    >
                                                        {/* <i className="fas fa-eye" /> */}
                                                        <SvgIcon
                                                            className={`changePasswordView-password-icon ${props.changePasswordShowPasswordIcon}`}
                                                        >
                                                            <path d="M0 0h24v24H0V0z" fill="none" />
                                                            <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
                                                        </SvgIcon>
                                                    </div>
                                                </div>
                                            </Grid>
                                            {/* Input repetir contraseña */}
                                            <Grid item xs={12}>
                                                <div className="change-password-input-container">
                                                    <div className="change-password-input-wrapper">
                                                        <i className="fas fa-lock change-password-input-icon" />
                                                    </div>
                                                    <input
                                                        ref={lastInputRef}
                                                        placeholder={t(
                                                            "changePasswordView.placeholderConfirmPassword"
                                                        )}
                                                        type="password"
                                                        className="change-password-input"
                                                        id="confirmPassword"
                                                        onChange={(e) => props.onHandleGeneralChange(e)}
                                                        onKeyDown={handleKeyDown}
                                                    />
                                                    <div
                                                        className={`changePasswordView-show-password-icon ${props.changePasswordShowPasswordConfirmIcon}`}
                                                        onClick={props.onHandleShowPasswordConfirm}
                                                    >
                                                        {/* <i className="fas fa-eye" /> */}
                                                        <SvgIcon
                                                            className={`changePasswordView-password-icon ${props.changePasswordShowPasswordConfirmIcon}`}
                                                        >
                                                            <path d="M0 0h24v24H0V0z" fill="none" />
                                                            <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
                                                        </SvgIcon>
                                                    </div>
                                                </div>
                                            </Grid>

                                            {/* Mensajes de error */}
                                            {props.errorForm === true ? (
                                                <Grid item xs={12}>
                                                    <div className="change-password-container-error-label">
                                                        <p className="change-password-error-label">
                                                            <span>{props.errorMessage}</span>
                                                            <div
                                                                className="change-password-error-label-icon-close"
                                                                onClick={props.onHandleHideError}
                                                            >
                                                                <i className="fas fa-times" />
                                                            </div>
                                                        </p>
                                                    </div>
                                                </Grid>
                                            ) : null}
                                        </Grid>

                                        {/* Boton cambiar contraseña */}

                                        {props.goToChangePasswordScreen ? (
                                            <div
                                                item
                                                xs={12}
                                                lg={12}
                                                md={12}
                                                sm={12}
                                                es={12}
                                                className="change-password-form-container-buttons"
                                            >
                                                <button
                                                    onClick={props.goToChangePasswordScreen}
                                                    className={"changePasswordView-btn-secondary"}
                                                >
                                                    {t("profile.action.closeDownload")}
                                                </button>
                                                {/* <div style={{ marginLeft: 16 }}></div> */}
                                                <button
                                                    onClick={() => props.onSubmitChangeUserPassword(t)}
                                                    className={"changePasswordView-btn-primary"}
                                                >
                                                    {t("changePasswordView.buttonChangePassword")}
                                                </button>
                                            </div>
                                        ) : (
                                            <div
                                                item
                                                xs={12}
                                                lg={12}
                                                md={12}
                                                sm={12}
                                                es={12}
                                                className="change-password-form-container-buttons"
                                            >
                                                <ButtonHLPure
                                                    nameBtn={t("changePasswordView.buttonChangePassword")}
                                                    onClickBtn={() => props.onSubmitChangeUserPassword(t)}
                                                    primary
                                                />
                                            </div>
                                        )}
                                    </Grid>
                                </Grid>
                            </Container>
                        </div>

                        {/* Footer od the page */}
                        <Grid container justify="center" alignItems="center">
                            <div className="footer-register-person" item>
                                <div className="footer-elements">
                                    <div className="footer-textR-person">
                                        <h2>Powered by A3 Cloud Microservices, S.A.P.I. de C.V.</h2>
                                    </div>
                                    <div className="footer-textL-person">
                                        <h2
                                            onClick={() => {
                                                openModalTermsCond(true);
                                            }}
                                        >
                                            {t("simpleFooter.noticeOfprivacy")}
                                        </h2>
                                        {/*<hr class="linkHref"/>*/}
                                    </div>
                                </div>
                            </div>
                        </Grid>

                        {/* Alerts of Notification Loadign, Completed and Error */}
                        <DialogSystemGLPure
                            {...props}
                            toggleLoadingRequesting={props.toggleLoadingRequesting}
                            toggleCompletedRequesting={props.toggleCompletedRequesting}
                            toggleErrorRequesting={props.toggleErrorRequesting}
                            messageComplete={t("dialogSignRequestPure.changePassword.InUserInvitedReg")}
                        />
                        <DialogPrivacy
                            {...props}
                            openModalTermsCond={openModalTermsCond}
                            modalTermsCond={modalTermsCond}
                        />
                    </div>
                )
            }
        </div>

    );
};
export { ChangePasswordView as default };
